import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ExtendableGroup } from '../../components/extendable-group';
import { asHtml } from '../../helpers/markdown';
import { getRetailerPromos } from '../../selectors/retailer';

interface ImageProps {
  image: string;
  title: string;
}

const Image = ({ image, title }: ImageProps) => {
  if (!image) return null;

  return (
    <div className="column valign-top">
      <img src={`${image}?w=400&h=230&q=72`} alt={title} className="column-image" />
    </div>
  );
};

const RetailerPromos = () => {
  const { t } = useTranslation(['retailer']);
  const promos = useSelector(getRetailerPromos).slice(0, 3);

  if (!promos.length) return null;

  const list = promos.map((promo) => {
    if (promo.link && promo.link.url)
      return (
        <div key={promo.title} data-am-columnblock="" className="m-b-double">
          <Image image={promo.image} title={promo.title} />
          <div className="column">
            <div className="font-medium m-b-half">{promo.title}</div>
            <ExtendableGroup
              modifiers="small"
              label="Visa mer"
              extended={!promo.description || promo.description.length < 500}
            >
              <div
                data-am-content=""
                dangerouslySetInnerHTML={{ __html: asHtml(promo.description) }}
              />
              <div className="m-t-half">
                <a
                  href={promo.link.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  data-am-link=""
                >
                  {promo.link.name ? promo.link.name : 'Läs mer'}
                  <i className="icon-chevron-right m-l-mini" />
                </a>
              </div>
            </ExtendableGroup>
            <div className="m-b-double hidden-md" />
          </div>
        </div>
      );
    return (
      <div key={promo.title} data-am-columnblock="" className="m-b">
        <Image image={promo.image} title={promo.title} />
        <div className="column">
          <div className="font-medium m-b-half">{promo.title}</div>
          <div data-am-content="" dangerouslySetInnerHTML={{ __html: asHtml(promo.description) }} />
          <div className="m-b-double hidden-md" />
        </div>
      </div>
    );
  });

  return (
    <>
      <h2 className="h3">{t('currentOffers', { ns: 'retailer' })}</h2>
      {list}
      <div className="m-b-double hidden-lt-md" />
    </>
  );
};

export default RetailerPromos;
